import nxModule from 'nxModule';
import StatusBasedService from "./statusBasedService";

nxModule.factory('informationMessageService', (statusService) =>
  new StatusBasedService({
    property: 'informationMessage',
    statusService: statusService,
    optional: true
  }));